// extracted by mini-css-extract-plugin
export default {"container":"e8v_o_container"};